<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-header">
        <a class="navbar-brand" href="#">
          <a id="menu-hamburger" @click.prevent="displayMenu()" class="glyphicon glyphicon-menu-hamburger"></a> HUB</a>
        <li id="logout-small" class="pull-right">
            <a @click.prevent="logout()" title="Logout?" class="glyphicon glyphicon-user logout"></a>
        </li>
      </div>
      <ul id="navmenu" class="nav navbar-nav">
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/Agenda">Agenda</router-link></li>
        <li><router-link to="/clientes/sup">Clientes</router-link></li>
        <li><router-link to="/clientes/cob/docs">Docs</router-link></li>
        <li v-if="nivel==='2'"><router-link to="/emails">Email</router-link></li>
        <li><router-link to="/manuais">Manuais</router-link></li>  
        <li v-if="nivel==='2'"><router-link to="/mensagens">Mensagens</router-link></li>
        <li><router-link to="/pacotes">Pacotes</router-link></li>
        <li><router-link to="/tarefas">Tarefas</router-link></li>
        <li v-if="nivel==='2'"><router-link to="/usuarios">Usuarios</router-link></li>
        <li><a href="http://192.168.1.80:8081/scriptcase/app/PsAdmin/cons_atualizacoes/?script_case_init=3641&script_case_session=a4af4st5akomnrr0odnnqh7d60" target="_blank">Psweb Packs</a></li>
        <li><a href="http://192.168.1.80:8081/scriptcase/app/PsAdmin/cons_bancos/?nmgp_outra_jan=true&nmgp_start=SC&script_case_session=l2plpkd0vjake865mfv3gsn2h6&6073" target="_blank">BDPS</a></li>   
      </ul>
      <div class="smart">
        <form class="navbar-form" role="search">
          <div class="input-group">
              <input @keyup.enter.prevent="search()" ref="iptSearchKeyword" type="text" class="form-control" placeholder="Search" name="q">
              <div class="input-group-btn">
                  <button @click.prevent="search()" class="btn btn-primary"><i class="glyphicon glyphicon-search"></i></button>
              </div>
          </div>
        </form>
      </div>
      <ul v-if="isVisibleMenu" id="navmenusmall" class="nav navbar-nav">
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/Agenda">Agenda</router-link></li>
          <li><router-link to="/clientes/sup">Clientes</router-link></li>
          <li><router-link to="/clientes/cob/docs">Docs</router-link></li>
          <li v-if="nivel==='2'"><router-link to="/emails">Email</router-link></li>
          <li><router-link to="/manuais">Manuais</router-link></li>    
          <li v-if="nivel==='2'"><router-link to="/mensagens">Mensagens</router-link></li>
          <li><router-link to="/pacotes">Pacotes</router-link></li>
          <li><router-link to="/tarefas">Tarefas</router-link></li>
          <li v-if="nivel==='2'"><router-link to="/usuarios">Usuarios</router-link></li>
          <li><a href="http://192.168.1.80:8081/scriptcase/app/PsAdmin/cons_atualizacoes/?script_case_init=3641&script_case_session=a4af4st5akomnrr0odnnqh7d60" target="_blank">Psweb Packs</a></li>
          <li><a href="http://192.168.1.80:8081/scriptcase/app/PsAdmin/cons_bancos/?nmgp_outra_jan=true&nmgp_start=SC&script_case_session=l2plpkd0vjake865mfv3gsn2h6&6073" target="_blank">BDPS</a></li>   
        </ul>
      <ul id="logout" class="nav navbar-nav pull-right">
        <li>
          <a @click.prevent="logout()" title="Logout?" class="glyphicon glyphicon-user logout"></a>
        </li>
      </ul>
      <div class="pull-right">
          <form class="navbar-form" role="search">
            <div class="input-group">
                <input @keyup.enter.prevent="search()" ref="iptSearchKeyword2" type="text" class="form-control" placeholder="Search" name="q">
                <div class="input-group-btn">
                    <button @click.prevent="search()" class="btn btn-primary"><i class="glyphicon glyphicon-search"></i></button>
                </div>
            </div>
          </form>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data () {
    return {
      nivel: -1,
      isVisibleMenu: false
    }
  },
  methods: {
    search () {
      let keyword = this.$refs.iptSearchKeyword.value + this.$refs.iptSearchKeyword2.value
      this.$router.push({path: this.$route.path, query: {s: keyword}})
    },
    cleanSearch () {
      this.$refs.iptSearchKeyword.value = ''
    },
    logout () {
      this.$emit('logout')
    },
    displayMenu () {
      this.isVisibleMenu = !this.isVisibleMenu
    },
    focusIptSearch () {
      if (this.$refs.iptSearchKeyword === undefined) {
        this.$nextTick(() => { this.$refs.iptSearchKeyword.focus() })
      } else {
        this.$nextTick(() => { this.$refs.iptSearchKeyword2.focus() })
      }
    }
  },
  created: function () {
    this.nivel = this.$root.nivel
  },
  watch: {
    '$route' (to, from) {
      this.nivel = this.$root.nivel
      if (this.$route.query.s === undefined) {
        this.cleanSearch()
      }
      if (this.isVisibleMenu) {
        this.displayMenu()
      }
    }
  }
}
</script>

<style scoped>
  .smart {
    display: none;
  }
  #navmenu {
    display: block;
  }
  #navmenusmall {
    display: none;
  }
  a.glyphicon-menu-hamburger {
    display: none;
  }
  #logout {
    display: inherit;
  }
  #logout-small {
    display: none;
  }
  nav {
    z-index: 100;
  }
  li a.logout{
    margin-top: 2px;
    padding: 10px;
    font-size: 20px;
    border-bottom: 2px solid #c00;
  }
  li a.logout:hover{
    border-radius: 50px;
    background: #c00;
    color: #fff;
  }
  @media (max-width: 499px) {
    .smart {
      display: block;
    }
    #navmenu {
      display: none;
    }
    #navmenusmall {
      display: block;
      height: 100vh;
    }
    a.glyphicon-menu-hamburger {
      display: inline-block;
    }
    #logout {
      display: none;
    }
    #logout-small {
      display: inherit;
    }
    #busca {
      display: block;
      float: none;
      text-align: center;
    }
    .pull-right {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue